import React, { Fragment } from 'react';
import RoutingMiddleware from './RoutingMiddleware';
import {
  BrowserRouter as Router
} from "react-router-dom";
import LiproHeader from './common/LiproHeader';
import '../App.css'
export default function () {

  return (
    <Router>
      <Fragment>
        <div className="App" m={3}>
          <LiproHeader />

          <RoutingMiddleware />
        </div>
      </Fragment>

    </Router>
  );
}